import React from "react";

const CookiePolicy = () => {
  return (
    <div className="terms-container">
      <h1>Cookie Policy</h1>

      <p>
        Our website may use cookies to improve your browsing experience.
      </p>

      <h3>What Are Cookies?</h3>
      <p>
        Cookies are small files stored on your device that help websites
        remember user preferences and improve performance.
      </p>

      <h3>How We Use Cookies</h3>
      <p>
        We use cookies to analyze website traffic and enhance user
        experience.
      </p>

      <h3>Managing Cookies</h3>
      <p>
        You can disable cookies through your browser settings if you
        prefer.
      </p>
    </div>
  );
};

export default CookiePolicy;